<template>
	<section
		v-if="recommendations.length"
		class="not-found-recommendations main-wrapper w-full pb-8"
	>
		<StoryblokComponent
			v-for="blok in recommendations"
			:key="blok._uid"
			:blok="blok"
		/>
	</section>
</template>

<script setup lang="ts">
// `not-found-recommendations` is a styling hook for templates.
import type { BlokProductRecommendations } from "~/types/storyblok/storyblok";

// Templates that fork the app store do not carry the field, hence the fallback.
const appStore = useAppStore() as {
	notFoundRecommendations?: BlokProductRecommendations[];
};
const recommendations = computed(() => appStore.notFoundRecommendations ?? []);
</script>
